<template>
  <div class="bto-sb-widget bto-sb-widget-bets-foryou">
    <div class="bto-sb-widget-title">
      <h3>{{ t('W.receng') }}</h3>
    </div>
    <div class="bto-sb-widget-content">
      <ul>
        <li>
          <div class="bto-sb-bets-foryou-event-name">
            <span class="bto-sb-sports-icon basketball"></span>
            <span class="bto-sb-bets-foryou-event-item" title="New Zealand Breakers vs Adelaide 36Ers">
                                        <span class="bto-sb-bets-foryou-event-home">New Zealand Breakers</span>
                                        <span class="bto-sb-bets-foryou-event-score-vs">vs</span>
                                        <span class="bto-sb-bets-foryou-event-away">Adelaide 36Ers</span>
                                    </span>
          </div>
          <div class="bto-sb-bets-foryou-event-info">
            <span class="bto-sb-bets-foryou-event-time-live">3Q 21'</span>
            <span class="bto-sb-bets-foryou-event-odd">
                                        <a href="#" title="">
                                            <i>1</i>
                                            <i>1.20</i>
                                        </a>
                                    </span>
            <span class="bto-sb-bets-foryou-event-odd">
                                        <a href="#" title="">
                                            <i>2</i>
                                            <i>4.35</i>
                                        </a>
                                    </span>
            <span class="bto-sb-bets-foryou-event-more">
                                        <a href="#" title="">
                                            +38
                                        </a>
                                    </span>
          </div>
        </li>
        <li>
          <div class="bto-sb-bets-foryou-event-name">
            <span class="bto-sb-sports-icon soccer"></span>
            <span class="bto-sb-bets-foryou-event-item" title="Manchester City vs Arsenal">
                                        <span class="bto-sb-bets-foryou-event-home">Manchester City</span>
                                        <span class="bto-sb-bets-foryou-event-score-vs">vs</span>
                                        <span class="bto-sb-bets-foryou-event-away">Arsenal</span>
                                    </span>
          </div>
          <div class="bto-sb-bets-foryou-event-info">
            <span class="bto-sb-bets-foryou-event-time">14:15 05-11</span>
            <span class="bto-sb-bets-foryou-event-odd">
                                        <a href="#" title="">
                                            <i>1</i>
                                            <i>1.48</i>
                                        </a>
                                    </span>
            <span class="bto-sb-bets-foryou-event-odd">
                                        <a href="#" title="">
                                            <i>X</i>
                                            <i>4.70</i>
                                        </a>
                                    </span>
            <span class="bto-sb-bets-foryou-event-odd">
                                        <a href="#" title="">
                                            <i>2</i>
                                            <i>6.30</i>
                                        </a>
                                    </span>
            <span class="bto-sb-bets-foryou-event-more">
                                        <a href="#" title="">
                                            +183
                                        </a>
                                    </span>
          </div>
        </li>
        <li>
          <div class="bto-sb-bets-foryou-event-name">
            <span class="bto-sb-sports-icon soccer"></span>
            <span class="bto-sb-bets-foryou-event-item" title="Honduras vs Australia">
                                        <span class="bto-sb-bets-foryou-event-home">Honduras</span>
                                        <span class="bto-sb-bets-foryou-event-score-vs">vs</span>
                                        <span class="bto-sb-bets-foryou-event-away">Australia</span>
                                    </span>
          </div>
          <div class="bto-sb-bets-foryou-event-info">
            <span class="bto-sb-bets-foryou-event-time">22:00 10-11</span>
            <span class="bto-sb-bets-foryou-event-odd">
                                        <a href="#" title="">
                                            <i>1</i>
                                            <i>1.48</i>
                                        </a>
                                    </span>
            <span class="bto-sb-bets-foryou-event-odd">
                                        <a href="#" title="">
                                            <i>X</i>
                                            <i>4.70</i>
                                        </a>
                                    </span>
            <span class="bto-sb-bets-foryou-event-odd">
                                        <a href="#" title="">
                                            <i>2</i>
                                            <i>6.30</i>
                                        </a>
                                    </span>
            <span class="bto-sb-bets-foryou-event-more">
                                        <a href="#" title="">
                                            +183
                                        </a>
                                    </span>
          </div>
        </li>
        <li>
          <div class="bto-sb-bets-foryou-event-name">
            <span class="bto-sb-sports-icon tennis"></span>
            <span class="bto-sb-bets-foryou-event-item" title="Kerber, Angelique vs Barty, Ashleigh">
                                        <span class="bto-sb-bets-foryou-event-home">Kerber, Angelique</span>
                                        <span class="bto-sb-bets-foryou-event-score-vs">vs</span>
                                        <span class="bto-sb-bets-foryou-event-away">Barty, Ashleigh</span>
                                    </span>
          </div>
          <div class="bto-sb-bets-foryou-event-info">
            <span class="bto-sb-bets-foryou-event-time">15:00 12-11</span>
            <span class="bto-sb-bets-foryou-event-odd">
                                        <a href="#" title="">
                                            <i>1</i>
                                            <i>1.48</i>
                                        </a>
                                    </span>
            <span class="bto-sb-bets-foryou-event-odd">
                                        <a href="#" title="">
                                            <i>2</i>
                                            <i>6.30</i>
                                        </a>
                                    </span>
            <span class="bto-sb-bets-foryou-event-more">
                                        <a href="#" title="">
                                            +183
                                        </a>
                                    </span>
          </div>
        </li>
        <li>
          <div class="bto-sb-bets-foryou-event-name">
            <span class="bto-sb-sports-icon soccer"></span>
            <span class="bto-sb-bets-foryou-event-item" title="Newcastle United vs Bournemouth">
                                        <span class="bto-sb-bets-foryou-event-home">Newcastle United</span>
                                        <span class="bto-sb-bets-foryou-event-score-vs">vs</span>
                                        <span class="bto-sb-bets-foryou-event-away">Bournemouth</span>
                                    </span>
          </div>
          <div class="bto-sb-bets-foryou-event-info">
            <span class="bto-sb-bets-foryou-event-time">18:00 13-11</span>
            <span class="bto-sb-bets-foryou-event-odd">
                                        <a href="#" title="">
                                            <i>1</i>
                                            <i>1.48</i>
                                        </a>
                                    </span>
            <span class="bto-sb-bets-foryou-event-odd">
                                        <a href="#" title="">
                                            <i>X</i>
                                            <i>4.70</i>
                                        </a>
                                    </span>
            <span class="bto-sb-bets-foryou-event-odd">
                                        <a href="#" title="">
                                            <i>2</i>
                                            <i>6.30</i>
                                        </a>
                                    </span>
            <span class="bto-sb-bets-foryou-event-more">
                                        <a href="#" title="">
                                            +183
                                        </a>
                                    </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BetsForYouWidget',
    // data() {
    //     return{
    //     };
    // },
    // methods: {
    // },
  };
</script>
